import { createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { seasonalRulesQuery } from 'components/domain/property/seasonality/seasonalRulesQuery';
import CommonTable from 'components/table/CommonTable';
import useServerFilteredTable from 'components/table/hooks/useServerFilteredTable';
import { SeasonalRule } from 'models/seasonality/SeasonalRule';
import ActionsCell from './cells/ActionsCell';
import AppliedCell from './cells/AppliedCell';
import AppliesToCell from './cells/AppliesToCell';
import ColorCell from './cells/ColorCell';
import DateCell from './cells/DateCell';
import DetailsCell from './cells/DetailsCell';

const PAGE_SIZE = 20;

const SeasonalRulesTable = () => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<SeasonalRule>();

  const columns = [
    columnHelper.display({
      id: 'name',
      header: t('pageProperty.seasonality.table.name'),
      cell: ({ row }) => row.original.name,
    }),
    columnHelper.display({
      id: 'date',
      header: t('pageProperty.seasonality.table.date'),
      cell: DateCell,
    }),
    columnHelper.display({
      id: 'color',
      header: t('pageProperty.seasonality.table.colour'),
      cell: ColorCell,
    }),
    columnHelper.display({
      id: 'applied',
      header: t('pageProperty.seasonality.table.applied'),
      cell: AppliedCell,
      meta: { showCellTooltip: false },
    }),
    columnHelper.display({
      id: 'properties',
      header: t('pageProperty.seasonality.table.properties'),
      cell: AppliesToCell,
    }),
    columnHelper.display({
      id: 'details',
      header: t('pageProperty.seasonality.table.details'),
      cell: DetailsCell,
      meta: { showCellTooltip: false },
    }),
    columnHelper.display({
      id: 'actions',
      header: t('common.actions'),
      cell: ActionsCell,
      meta: { showCellTooltip: false },
    }),
  ];

  const { tableInstance, isLoading } = useServerFilteredTable({
    columns,
    getQuery: (options) => seasonalRulesQuery(options),
    pageSize: PAGE_SIZE,
  });

  return (
    <CommonTable
      data-testid="seasonal-rules-table"
      emptyState={t('pageProperty.seasonality.table.emptyTable')}
      isLoading={isLoading}
      tableInstance={tableInstance}
    />
  );
};

export default SeasonalRulesTable;
